import type { StatusTone } from '@/components/px/StatusPill'

import type { FlaggedDifferenceStatus } from '../types'

/**
 * The ONE `FlaggedDifferenceStatus` → tone map for this feature. The
 * reconciliation panel and the trail's reconciliation-trace list render the
 * same server enum and must not drift apart; keying the map by the enum makes
 * tsc prove it stays exhaustive when the server adds a status.
 */
export const DIFF_STATUS_TONE: Record<FlaggedDifferenceStatus, StatusTone> = {
  OPEN: 'review',
  PROPOSED: 'proposed',
  ACCEPTED: 'decided',
  FIXED: 'done',
  RERUN_REQUIRED: 'blocked'
}
